import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faFlipboard,
  faYoutube
} from '@fortawesome/free-brands-svg-icons'
import {
  faPlay,
  faTimes,
  faAngleDoubleLeft,
  faPlayCircle,
  faBars,
  faHome
} from '@fortawesome/free-solid-svg-icons'
import Fbapi from 'vue-fbapi'
import VueAnalytics from 'vue-analytics'
import VModal from 'vue-js-modal'
import Meta from 'vue-meta'

Vue.use(VModal, { dynamic: true })

library.add(faFacebookF, faTwitter, faInstagram, faPlay, faAngleDoubleLeft, faTimes, faWhatsapp, faPlayCircle, faBars, faHome, faFlipboard, faYoutube)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Fbapi, {
  appId: '1134891773353659',
  autoLogAppEvents: true,
  xfbml: true,
  version: 'v3.2'
})

Vue.use(VueAnalytics, {
  id: 'UA-80728886-38',
  router
})

Vue.config.productionTip = false

Vue.use(Meta)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')